/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar } from '@material-ui/core';
import React from 'react';

export interface IUserAvatar {
    currentUser : any;
    className ?: string;
}

const UserAvatar = (props : IUserAvatar) : React.ReactElement => {

    return (
        <>
            {
                props.currentUser &&
                <Avatar
                    className={ props.className ? props.className : ''}
                    variant='circular'
                    alt={props.currentUser.name}
                    src={props.currentUser.profilePictureURL}
                />
            }
        </>
    );
};

export default UserAvatar;